import { httpErrorHandler, HttpRequest } from "../../handler";

const SET_PRODUCTS = 'setProducts';
const SET_LIST_ALL_PRODUCTS = 'setListALlProducts';
const SET_LOADING_PRODUCTS_LISTING = 'setLoadingProduct';
const SET_SUBMITTING_PRODUCT = 'setSubmittingProduct';
const SET_EDIT_PRODUCTS = 'setEditProduct';

export default {
  namespaced: true,
  state: {
    isLoadingProduct: false,
    isSubmittingProduct: false,
    isLoadingProductCategory: false,
    productsListing: { pageMeta: null, products: [] },
    listALlProducts:  [],
    productCategories: { pageMeta: null, categories: [] },
    editProduct: {}
  },
  mutations: {
    [SET_PRODUCTS](state, payload) {
      state.productsListing = payload
    },
    [SET_LIST_ALL_PRODUCTS](state, payload) {
      state.listALlProducts = payload
    },
    [SET_LOADING_PRODUCTS_LISTING](state, payload) {
      state.isLoadingProduct = payload
    },
    [SET_SUBMITTING_PRODUCT](state, payload) {
      state.isSubmittingProduct = payload
    },
    [SET_EDIT_PRODUCTS](state, payload) {
      state.editProduct = payload
    }
  },
  actions: {
    async getAll(context, payload) {
      context.commit(SET_LOADING_PRODUCTS_LISTING, true)
      const url = 'localProduct/getAll'
      const { query } = payload
      const { search } = query
      const { success, result, message } = await HttpRequest.authorizedRequest(url, 'GET', {}, { search })
      if (success) {
        context.commit(SET_LIST_ALL_PRODUCTS, result)
      } else {
        httpErrorHandler(message)
      }
      context.commit(SET_LOADING_PRODUCTS_LISTING, false)
    },
    async getProducts(context, payload) {
      context.commit(SET_LOADING_PRODUCTS_LISTING, true)
      const url = 'localProduct'
      const { query } = payload
      const { category, search, ...rest } = query
      const { success, result, message } = await HttpRequest.authorizedRequest(url, 'GET', {}, { ...rest, search, isShowingAll: 1, category: category ? category : undefined })
      if (success) {
        context.commit(SET_PRODUCTS, result)
      } else {
        httpErrorHandler(message)
      }
      context.commit(SET_LOADING_PRODUCTS_LISTING, false)
    },
    async getById(context, payload) {
      const { id } = payload
      const url = `localProduct/${id}`
      const {success, result, message} = await HttpRequest.authorizedRequest(url, 'GET', {}, {}, {})
      if(success) {
        return result
      } else {
        httpErrorHandler(message) 
        return false
      }
    },
    async deleteProduct(context, payload) {
      context.commit(SET_LOADING_PRODUCTS_LISTING, true)
      const { id } = payload
      const url = `localProduct/${id}`
      const {success, message } = await HttpRequest.authorizedRequest(url, 'DELETE', {}, {}, {})
      if(success) {
        context.commit(SET_PRODUCTS, {
          pageMeta: context.state.productsListing.pageMeta,
          data: context.state.productsListing.data.filter(item => item._id != id)
        });
        alert("Successfully");
        context.commit(SET_LOADING_PRODUCTS_LISTING, false)
        return true;
      } else {
        httpErrorHandler(message) 
        context.commit(SET_LOADING_PRODUCTS_LISTING, false)
        return false
      }
    },
    async createProduct(context, payload) {
      const url = 'localProduct'
      const { data } = payload
      const { success, result, message } = await HttpRequest.authorizedRequest(url, 'POST', data)
      if (success) {
        return result
      } else {
        httpErrorHandler(message)
      }
    },
    async editProduct(context, payload) {
      context.commit(SET_EDIT_PRODUCTS, payload)
    },
    async updateProduct(context, payload) {
      const { data, productId } = payload
      const url = 'localProduct/update/' + productId
      const { success, result, message } = await HttpRequest.authorizedRequest(url, 'PATCH', data)
      if (success) {
        return result
      } else {
        httpErrorHandler(message)
      }
    },
    async updateShowing(context, payload) {
      const { data, productId } = payload
      const url = 'localProduct/' + productId + '/isShowing'
      const { success, result, message } = await HttpRequest.authorizedRequest(url, 'PATCH', data)
      if (success) {
        context.commit(SET_PRODUCTS, {
          pageMeta: context.state.productsListing.pageMeta,
          data: context.state.productsListing.data.map(item => {
            if(item._id === productId) {
              item.isShowing = data.isShowing;
            }

            return item;
          })
        })

        return result
      } else {
        httpErrorHandler(message)
      }
    },
  }
}